import PropTypes from 'prop-types';
import Button from '@mui/material/Button';

import { passSx } from '@gef-ui/material/components/utils';

export const ToggleButton = ({
	label,
	onClick,
	selected = false,
	disabled = false,
	clickableWhenSelected = false,
	sx,
	...props
}) => (
	<Button
		sx={[
			{
				borderRadius: 5,
				bgcolor: selected ? 'primary.main' : 'white.main',
				color: selected ? 'default' : 'common.black',
				fontWeight: 500,
				boxShadow:
					' 0px 3px 1px -2px rgba(141, 142, 143, 0.2), 0px 2px 2px 0px rgba(141, 142, 143, 0.14), 0px 1px 5px 0px rgba(141, 142, 143, 0.12)',
				':hover': {
					bgcolor: selected ? 'primary.main' : 'white.main',
					boxShadow: selected ? 'initial' : '0 8px 16px 0 rgba(233, 87, 61, 0.24)',
				},
			},
			...passSx(sx),
		]}
		disabled={disabled && !selected}
		variant="contained"
		color="error"
		onClick={!disabled && (!selected || clickableWhenSelected) ? onClick : undefined}
		{...props}
	>
		{label}
	</Button>
);

ToggleButton.propTypes = {
	className: PropTypes.string,
	clickableWhenSelected: PropTypes.bool,
	disabled: PropTypes.bool,
	label: PropTypes.string,
	onClick: PropTypes.func,
	selected: PropTypes.bool,
	sx: PropTypes.object,
};
export default ToggleButton;
